﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const effects_1 = require("redux-saga/effects");
const Utils_1 = require("../../Utils");
const app_commons_1 = require("@its-suite/app-commons");
class ErrorMessagesSaga {
    static *watcher() {
        yield effects_1.takeLatest(app_commons_1.MessagesActions.ActionTypes.SHOW_SNACKBAR_EXCEPTION_MESSAGE, ErrorMessagesSaga.showSnackbarExceptionMessage);
        yield effects_1.takeLatest(app_commons_1.MessagesActions.ActionTypes.SHOW_SNACKBAR_ERROR_MESSAGE, ErrorMessagesSaga.showSnackbarErrorMessage);
        yield effects_1.takeLatest(app_commons_1.MessagesActions.ActionTypes.SHOW_SNACKBAR_INFO_MESSAGE, ErrorMessagesSaga.showSnackbarInfoMessage);
    }
    static *showSnackbarExceptionMessage(action) {
        let store = yield effects_1.select();
        let message = Utils_1.getExceptionMessage(store.translate, action.payload.message);
        yield effects_1.put(app_commons_1.SnackbarMessageModule.actionCreators.show({ message, isError: action.payload.isError }));
    }
    static *showSnackbarErrorMessage(action) {
        yield effects_1.put(app_commons_1.SnackbarMessageModule.actionCreators.show(action.payload));
    }
    static *showSnackbarInfoMessage(action) {
        yield effects_1.put(app_commons_1.SnackbarMessageModule.actionCreators.show(action.payload));
    }
}
exports.ErrorMessagesSaga = ErrorMessagesSaga;
//# sourceMappingURL=SnackbarMessagesSaga.js.map